import BaseService from "./BaseService";

export default class LoginServices extends BaseService {
    public static sendOTP(postData: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'adminOtp', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                
            },
            body: JSON.stringify(postData)
        });
    }

    public static verifyOTP(postData: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'verifyAdminOtp', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                
            },
            body: JSON.stringify(postData)
        });
    }

    public static penTestingLogin() {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'login-pentesting', {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                
            }
        });
    }


}